const hasMeaningfulHtml = (value) =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim().length > 0;

export const getAIDocumentWorkspaceActions = (content, canEdit) => {
  const hasContent = hasMeaningfulHtml(content);
  return {
    editorVisible: true,
    previewEnabled: hasContent,
    saveEnabled: hasContent && Boolean(canEdit),
  };
};

export default getAIDocumentWorkspaceActions;
